<template>
  <section class="short-deck-preset-hole-cards-selector">
    <span class="short-deck-preset-hole-cards-text">Your cards:</span>
    <short-deck-individual-card-selector
      ref="holeCardOne"
      v-bind:cardString="presetHoleCards.holeCardOne"
      v-bind:presetCards="presetCards"
      v-bind:popoverDirectionClass="popoverDirectionClass"
      v-bind:disabled="disabled"
      v-on:select="setPresetHoleCard($event, 'holeCardOne')"
      v-on:deselect="$emit('removePresetHoleCard', 'holeCardOne')"
    />
    <short-deck-individual-card-selector
      ref="holeCardTwo"
      v-bind:cardString="presetHoleCards.holeCardTwo"
      v-bind:presetCards="presetCards"
      v-bind:popoverDirectionClass="popoverDirectionClass"
      v-bind:disabled="disabled"
      v-on:select="setPresetHoleCard($event, 'holeCardTwo')"
      v-on:deselect="$emit('removePresetHoleCard', 'holeCardTwo')"
    />
  </section>
</template>

<script>
import ShortDeckIndividualCardSelector from '@/components/short-deck/short-deck-individual-card-selector';
import _ from 'lodash';

export default {
  name: 'short-deck-hole-cards-selector',
  components: {
    'short-deck-individual-card-selector': ShortDeckIndividualCardSelector,
  },
  props: ['presetHoleCards', 'presetCommunityCards', 'popoverDirectionClass', 'disabled'],
  computed: {
    presetCards: function () {
      return _.union(this.presetHoleCards.array, this.presetCommunityCards.array);
    },
  },
  methods: {
    setPresetHoleCard: function (payload, position) {
      this.$emit('setPresetHoleCard', {
        card: payload.card,
        position: position
      });

      if (position === 'holeCardOne') {
        this.$refs.holeCardTwo.toggle();
        payload.e.stopPropagation();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .short-deck-preset-hole-cards-text {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/short-deck/short-deck-hole-cards-selector.vue